import { render, staticRenderFns } from "./NewEnviosView.vue?vue&type=template&id=0c79e416"
import script from "./NewEnviosView.vue?vue&type=script&lang=js"
export * from "./NewEnviosView.vue?vue&type=script&lang=js"
import style0 from "./NewEnviosView.vue?vue&type=style&index=0&id=0c79e416&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports